import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import OiButton from '../../../../../../shared/components/Common/OiButton/OiButton';

import { getBanks, setError, setProcessLoading, updateBankAccountByMerchant } from '../../../../../../store/action';
import ErrorPicker from '../../../../../../shared/components/Error';
import Index from '../../../../../../shared/components/OiForm/OiFormInput';
import FormCheckbox from '../../../../../../shared/components/FormCheckbox/FormCheckbox';
import ValidateNuban from '../../../../../../shared/helpers/NUBANVerify';
import { getARecord } from '../../../../../../shared/helpers/utils';

const UpdateBank = ({ selectedBankAccount }) => {
    const { allBanks, processLoading, error } = useSelector(({ Util }) => Util);
    const { merchantDetails } = useSelector(({ Merchants }) => Merchants);
    const dispatch = useDispatch();
    const [state, setState] = useState({
        validate: {
            alias: '',
            bankId: '',
            accountNumber: '',
            updatePrimaryAccounts: false
        },
        errors: {}
    });

    useEffect(() => {
        let validate = { ...state.validate };

        validate['alias'] =
            selectedBankAccount === undefined || selectedBankAccount.alias === undefined
                ? ''
                : selectedBankAccount.alias;

        validate['accountNumber'] =
            selectedBankAccount === undefined || selectedBankAccount.accountNumber === undefined
                ? ''
                : selectedBankAccount.accountNumber;
        validate['updatePrimaryAccounts'] =
            selectedBankAccount === undefined || selectedBankAccount.primaryAccount === undefined
                ? ''
                : selectedBankAccount.primaryAccount;
        setState({ ...state, validate });

        dispatch(getBanks());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedBankAccount]);

    const validate = () => {
        const {
            validate: { alias, bankId, accountNumber }
        } = state;

        const pattern = /^[0-9]*$/;

        let errors = {};

        if (alias.trim() === '') {
            errors.alias = 'Alias is required!';
        }
        if (bankId.trim() === '' || bankId.trim() === undefined) {
            errors.bankId = 'Bank is required!';
        }
        if (accountNumber.trim() === '') {
            errors.accountNumber = 'Account Number is required!';
        } else if (!pattern.test(accountNumber)) {
            errors.accountNumber = 'This field must contain numbers only!';
        } else if (accountNumber.trim().length < 10) {
            errors.accountNumber = 'BVN number must be a 11 digit value!';
        }

        return Object.keys(errors).length === 0 ? null : errors;
    };

    const validateProperty = input => {
        const { name, value } = input.target;
        const pattern = /^[0-9]*$/;

        if (name === 'alias') {
            if (value.trim() === '') return 'Alias is required!';
        }
        if (name === 'bankId') {
            if (value.trim() === '' || value.trim() === undefined) return 'Bank is required!';
        }
        if (name === 'accountNumber') {
            if (value.trim() === '') return 'Account Number is required!';
            if (!pattern.test(value)) return 'This field must contain numbers only!';
            if (value.trim().length < 10) return 'BVN number must be a 11 digit value!';
        }
    };

    const handleChange = event => {
        const { name, value } = event.target;

        if (name === 'updatePrimaryAccounts') {
            const validate = { ...state.validate };
            validate[name] = !state.validate.updatePrimaryAccounts;

            return setState({ ...state, validate });
        }

        const errors = { ...state.errors };
        const errorMessage = validateProperty(event);
        if (errorMessage) {
            errors[name] = errorMessage;
        } else {
            delete errors[name];
        }

        const validate = { ...state.validate };
        validate[name] = value;

        setState({ ...state, validate, errors });
    };

    const handleSubmit = event => {
        event.preventDefault();
        const { bankId, accountNumber } = state.validate;

        const { updatePrimaryAccounts, ...validateData } = state.validate;
        const bankAccountId = selectedBankAccount.id;
        const merchantId = merchantDetails[0]?.id;
        const primaryAccount = updatePrimaryAccounts;
        const value = { ...validateData, merchantId, primaryAccount };

        const selectedBank = getARecord(allBanks, 'id', bankId);
        const accountError = ValidateNuban(selectedBank.code, accountNumber);

        if (!accountError) {
            dispatch(setProcessLoading(true));
            dispatch(updateBankAccountByMerchant({ value, bankAccountId }));
        }
        dispatch(setError(accountError));
    };

    const {
        validate: { alias, accountNumber, updatePrimaryAccounts },
        errors
    } = state;

    return (
        <React.Fragment>
            <h2 className="settings__header u-half-gradient-bg">Update Bank Account</h2>
            <form className="oi-form" onSubmit={handleSubmit}>
                <div className="oi-form__section  u-margin-top-3_5">
                    <div className="oi-form__group">
                        <div className="oi-form__associate u-margin-top-switch ">
                            <Index
                                labelClass="oi-form__label-primary"
                                inputClass="oi-form__input-primary  oi-form__input--height4"
                                name="alias"
                                inputValue={alias}
                                type="text"
                                label="Account Name"
                                hook="alias"
                                onChange={handleChange}
                                placeholder="Settlement Account 1"
                                auto="new-password"
                                error={errors.alias}
                            />
                        </div>
                    </div>

                    <div className="oi-form__group">
                        <div className="oi-form__associate u-margin-top-switch ">
                            <label className="oi-form__label-primary  oi-form__label-primary--mod" htmlFor="bankId">
                                Select Bank
                            </label>

                            <select
                                className="oi-form__select-primary oi-form__input--height4"
                                name="bankId"
                                id="select-bank"
                                onChange={handleChange}>
                                <option value="">Select Your Bank</option>
                                {allBanks.map((item, idx) => (
                                    <option value={item.id} key={idx}>
                                        {item.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        {errors['bankId'] !== undefined && (
                            <div className="oi-validation__container oi-validation__error">{errors.bankId}</div>
                        )}
                    </div>

                    <div className="oi-form__group">
                        <div className="oi-form__associate u-margin-top-switch ">
                            <Index
                                labelClass="oi-form__label-primary"
                                inputClass="oi-form__input-primary  oi-form__input--height4"
                                name="accountNumber"
                                inputValue={accountNumber}
                                type="text"
                                label="Account Number"
                                hook="account-number"
                                onChange={handleChange}
                                placeholder="Enter Account Number"
                                auto="new-password"
                                error={errors.accountNumber}
                            />
                        </div>
                    </div>
                    <div className="oi-form__group">
                        <div className="oi-form__associate u-margin-top-switch ">
                            <FormCheckbox
                                divClass="oi-form__checkbox-group"
                                labelClass="oi-form__checkbox-label  u-checkbox-margin4"
                                inputClass="oi-form__checkbox-input"
                                spanClass="oi-form__checkbox-button"
                                name="updatePrimaryAccounts"
                                type="checkbox"
                                label="Make this my Primary Account"
                                hook="updatePrimaryAccounts"
                                onChange={handleChange}
                                checked={updatePrimaryAccounts}
                            />
                        </div>
                    </div>
                </div>

                <div className="u-margin-top-3_5">
                    <ErrorPicker error={error} />
                    <OiButton
                        disabled={validate()}
                        buttonLoader={processLoading}
                        styles="oi-btn oi-btn--primary oi-btn--stretch oi-btn--radius5 oi-btn--height45 | u-font14sb"
                        type="submit">
                        Update Bank Account
                    </OiButton>
                </div>
            </form>
        </React.Fragment>
    );
};

export default UpdateBank;
